import React, { useState } from 'react';
import params from 'configs/params';
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import { toast } from 'react-toastify';
import { getText } from 'helpers/app/getText';

const CheckoutForm = ({ id, t, setSelectedPSPType, setIsPaymentCanceled }) => {
  const stripe = useStripe();
  const elements = useElements();

  const [errorMessage, setErrorMessage] = useState(null);

  const onCancel = () => {
    localStorage.removeItem('secret');
    localStorage.removeItem('stripeAccountID');
    setSelectedPSPType('');
    setIsPaymentCanceled();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `${params.baseUrl}${id}`,
      },
    });

    if (error) {
      setErrorMessage(error.message);
      localStorage.removeItem('secret');
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement
        onLoadError={(err) => {
          toast.error(getText('main:STRIPE_PAYMENT_FAILED_MSG'));
        }}
      />
      <div className="box-charging">
        <button type="button" onClick={() => onCancel()} className="btn pay-now-cancel-btn mt-10">
          {getText('main:CANCEL')}
        </button>
        <button disabled={!stripe} className="btn pay-now-btn mt-10 pay-now-submit-btn ml-2">
          {getText('main:PAY_NOW')}
        </button>
      </div>
      {errorMessage?.length > 0 && <div className="alert alert-danger mt-10">{errorMessage && <p className="mb-0">{errorMessage}</p>}</div>}
    </form>
  );
};

export default CheckoutForm;
